import DGTextbox from 'components/FormControls/Textbox/DGTextbox';
import React, { Component } from 'react'
import { Container, Dropdown, Grid, Pagination, Rating, Segment, Tab, Table, TableRow } from 'semantic-ui-react'
import { getSellerReviews, getSellerReviewStatus, updateSellerReviewStatus } from 'services/Manager';
import { SellerReviewStatus } from 'constants/SellerReviewStatus';
import Formsy from 'formsy-react';
import _ from 'lodash';

import './SellerReviewContainer.less'

const initialState = { sellerReviews: [], sellerID: 0, status: null, reviewStatus: [], totalPages: 1, activePage: 1, totalRecordCount: 0 }

class SellerReviewContainer extends Component {


    constructor(props){
        super(props);
        this.state = initialState;
    }

    async componentDidMount() {
        
        this.setState({status: SellerReviewStatus.PENDING}, () => {
            this.searchSellerReviews();
        })
        
        //const reviewStatusResponse = await getSellerReviewStatus();

        const status = [];

        status.push({value: SellerReviewStatus.PENDING, text: 'Pending', selected: true});
        status.push({value: SellerReviewStatus.APPROVED, text: 'Approved'});
        status.push({value: SellerReviewStatus.REJECTED, text: 'Rejected'});
        this.setState({reviewStatus: status});

        /*if(reviewStatusResponse.resStatus == 200){
            const status = _.map(reviewStatusResponse.data, (item) => {
                return {value: item.sellerFeedbackStatusID, text: item.name }
            });

            this.setState({reviewStatus: status});
        }*/

    }

    searchSellerReviews = async () => {
        const sellerReviewsResponse = await getSellerReviews(this.state.sellerID, this.state.status, this.state.activePage, 20);

        if(sellerReviewsResponse.resStatus == 200){
            const sellerReviews = sellerReviewsResponse.data.reviews;
            const totalRecords = +sellerReviewsResponse.data.count;
            const numberOfPages = Math.ceil(totalRecords / 20);

            
            this.setState({sellerReviews: sellerReviews, totalPages: numberOfPages, totalRecordCount: totalRecords});
        }
    }

    onStatusChange = (e, data) => {
        const status = Number(data.value);
        if(isNaN(status)){
            this.setState({status: null});
        }
        else{
        this.setState({status: status});
        }
    }

    onApprovalRejection = async (sellerFeedbackID, status) => {
        console.log(sellerFeedbackID, status);
        const updateResponse = await updateSellerReviewStatus(sellerFeedbackID, status);

        if(updateResponse.resStatus == 200){
            this.searchSellerReviews();
        }
    }

    onPageChange = (e, data) => {
        this.setState({activePage: data.activePage}, () => {
            this.searchSellerReviews();
        });
        
    }

    onRequestIDClickHandler = (requestID) => {
        this.props.history.push('/request/'+requestID);
    }

    render() {
        return (
            <Container fluid className="review-list-container">
            <div className="main-page-panel">
            <div className="content-panel">
            <div className="mobile-header">
                    <div className="main-heading">
                        Business Reviews
                    </div>
                </div>
                <Segment fluid>
                    <Formsy>
                    <Grid>
                        <Grid.Row style={{alignItems: 'center'}}>
                            {/*<Grid.Column width={8}>
                                <DGTextbox name="sellerid" label="Seller ID"></DGTextbox>
                            </Grid.Column>*/}
                            <Grid.Column width={3}>
                                <Dropdown clearable className="list-box" placeholder='Status' fluid selection options={this.state.reviewStatus} onChange={this.onStatusChange} defaultValue={SellerReviewStatus.PENDING} />
                            </Grid.Column>
                            <Grid.Column width={1}>
                                <button className="button-submit" onClick={this.searchSellerReviews}>Submit</button>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                    </Formsy>
                </Segment>
                <Pagination totalPages={this.state.totalPages} activePage={this.state.activePage} disabled={this.state.totalRecordCount == 0 || this.state.totalRecordCount <= 20}  onPageChange={this.onPageChange}  />
                <Table>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>
                                Request
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                Business
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                Customer
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                Rating
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                Review
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                Status
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {this.state.sellerReviews.length == 0 && <TableRow>
                            <Table.Cell colSpan={5}>
                                No records found
                            </Table.Cell>
                        </TableRow>}

                        {this.state.sellerReviews.length > 0 && _.map(this.state.sellerReviews, (item) => {
                            return <Table.Row>
                                <Table.Cell className={"request-id-container"} onClick={()=> {this.onRequestIDClickHandler(item.singleBuyerRequestID)}}>
                                    {item.singleBuyerRequestID}
                                </Table.Cell>
                                <Table.Cell>
                                    {item.sellerName}
                                </Table.Cell>
                                <Table.Cell>
                                    {`${item.first} ${item.last}`}
                                </Table.Cell>
                                <Table.Cell>
                                    <Rating icon="star" maxRating={5} rating={item.rating} />
                                </Table.Cell>
                                <Table.Cell>
                                    {item.review}
                                </Table.Cell>
                                <Table.Cell>
                                    {item.status}
                                </Table.Cell>
                                <Table.Cell>
                                <Dropdown
                                            text='Actions'
                                            icon='chevron circle down'
                                            floating
                                            labeled
                                            button

                                            className='icon btn-action edit'
                                            
                                        >
                                            <Dropdown.Menu>

                                                <Dropdown.Item icon="check" text="Approve" onClick={() => this.onApprovalRejection(item.sellerFeedbackID, SellerReviewStatus.APPROVED)}  />
                                                <Dropdown.Item icon="delete" text="Reject" onClick={() => this.onApprovalRejection(item.sellerFeedbackID, SellerReviewStatus.REJECTED)} />
                                                
                                            </Dropdown.Menu>
                                        </Dropdown>
                                </Table.Cell>
                            </Table.Row>
                        })
                        }
                    </Table.Body>
                </Table>
            
                <Pagination totalPages={this.state.totalPages} activePage={this.state.activePage} disabled={this.state.totalRecordCount == 0 || this.state.totalRecordCount <= 20}  onPageChange={this.onPageChange}  />
            </div>
            
            </div>

</Container>
        )
    }
}

export default SellerReviewContainer
